import React from 'react'

import classNames from 'classnames'

import { CommonManageIcon } from '@local/assets/icons'

import Clickable from '@web/components/Clickable'
import { ClickHandler } from '@web/types'

import styles from './Button.module.scss'

interface Props {
  alt?: string
  clickHandler?: ClickHandler
  clickCode?: string
  buttonClass?: string
  disabled?: boolean
  iconStyleClass?: string
  isPopupOpen: boolean
}

const ButtonContextMenu = ({
  alt,
  clickHandler,
  clickCode,
  buttonClass,
  disabled,
  isPopupOpen,
  iconStyleClass = '',
}: Props) => {
  return (
    <Clickable
      className={classNames(styles.btn_manage, buttonClass)}
      onClick={clickHandler}
      nClickCode={clickCode}
      disabled={disabled}
      aria-haspopup="true"
      aria-expanded={isPopupOpen}
    >
      <CommonManageIcon className={classNames(styles.icon, iconStyleClass)} aria-hidden="true" />
      <span className="place_blind">{alt && alt.length > 0 ? alt : '부가 메뉴 보기'}</span>
    </Clickable>
  )
}

export default ButtonContextMenu
